export const POPUP_VISIBILITIES = {
  CHAT_SETTINGS: 'chatSettings',
  SEARCH_IN_CHAT: 'searchInChat',
  OPEN_MESSENGER: 'openMessenger',
  DELETE_CHAT: 'deleteChat',
  UNPINNED_CHAT: 'unpinnedChat',
  SECRET_CHAT: 'secretChat',
};
